export class AppInsightsImageFeedback{
    userId: string = '';
    rewardNumber: string = '';
    branchCode: string = '';
    partSearchTerm: string = '';
    feedbackType: string = '';
    additionalDetails: string = '';
}